import { Box, Divider, Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { FormStrucItem } from 'src/lib/types/types';
import BescheidDownload from '../../../../../../../components/ui-component/form-component/bescheid-download/BescheidDownload';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { APIS } from '../../../../../../../lib/constants/apis';
import { ANTRAGS_STATUS, PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import Schema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const FoerderBescheidAntragGlobal: FC<{}> = () => {
	const { application, setApplicationProperty } = useApplication();

	const rechtBefehltReadOnly = useMemo(() => {
		if (
			get(application, P.Antragstatus_Antragstatus.path) === ANTRAGS_STATUS.FoerderbescheidUebermittelt &&
			get(application, P.Angaben_Zum_Rechtsbehelf_Einreichdatum.path, null) === null
		) {
			return false;
		}
		return true;
	}, [application]);

	const bescheidPath = P.Foerderbescheid_Foerderbescheid.path;
	const bescheidDownloadOnPath = P.Freigabe_Uebermittlung_Heruntergeladen_Am.path;
	const bescheidDownloadStrapiFieldName = 'Freigabe_Uebermittlung_Heruntergeladen_Am';
	const apiName = APIS.Antrag;
	const apiObjectId = get(application, 'id');
	return (
		<>
			<ApplicationHeading title='Förderbescheid' description={PLATZHALTER_TEXT} />

			<Stack spacing={2}>
				<Typography variant='h4'>Herzlichen Glückwunsch!</Typography>
				<Typography>
					Wir freuen uns, Ihnen den Förderbescheid für Ihr beantragtes Förderprojekt übermitteln zu können. Mit einem Klick auf das Download-Icon
					rechts können Sie den Bescheid inklusive Anlagen herunterladen.{' '}
					<strong>Wir wünschen Ihnen einen guten Start und viel Erfolg für Ihr Projekt!</strong>
				</Typography>
			</Stack>
			<Box sx={{ mt: '2rem' }}>
				<BescheidDownload
					bescheidPath={bescheidPath}
					bescheidDownloadOnPath={bescheidDownloadOnPath}
					bescheidDownloadStrapiFieldName={bescheidDownloadStrapiFieldName}
					apiName={apiName}
					apiObjectId={apiObjectId}
					useSingleButtonVariant={true}
				/>
			</Box>

			<Divider sx={{ borderColor: '#000', mt: '2rem' }} />
			<Stack spacing={2} sx={{ mt: '1rem' }}>
				<Typography variant='h4'>Wichtig:</Typography>
				<Typography>
					Bitte beachten Sie die im PDF enthaltene <strong>Eingangsbestätigung und Erklärung zum Rechtsbehelf</strong>, die Sie hier unterschrieben hochladen können.
				</Typography>

				<Box sx={{ mt: '1rem' }}>
					<CreateForm
						formStruc={formStruc()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={rechtBefehltReadOnly}
					/>
				</Box>
			</Stack>
		</>
	);
};

export default FoerderBescheidAntragGlobal;

const formStruc = () => {
	const struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Angaben_Zum_Rechtsbehelf_Datei, hideLabel: true }],
			userProps: { direction: 'column', columnToDivide: 2 },
		},

		{
			fields: [
				{
					...P.Angaben_Zum_Rechtsbehelf_Anmerkung,
					maxCharLength: 2500,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
